import { useMutation } from '@tanstack/react-query';

import {
  postV1ServiceAgreementWithProvider,
  type ServiceAgreementWithProviderPostBody,
} from '../../../api/generated/pm';
import { invalidateServiceAgreementsWithProvider } from './dealers.queries';

/**
 * Mutation hooks for the dealer side of Service Agreements. POST is never
 * checked for `If-Match`, so no header handling applies.
 */

export const useCreateServiceAgreementWithProvider = () =>
  useMutation({
    mutationFn: async (payload: ServiceAgreementWithProviderPostBody) => {
      const { data } = await postV1ServiceAgreementWithProvider({
        body: payload,
        throwOnError: true,
      });
      return data;
    },
    onSuccess: () => {
      invalidateServiceAgreementsWithProvider();
    },
  });
